import { CopyOutlined, QuestionCircleOutlined, RollbackOutlined } from '@ant-design/icons'
import type { TabsProps } from 'antd'
import {
    App,
    Avatar,
    Button,
    Card,
    Col,
    Divider,
    Flex,
    Input,
    Row,
    Space,
    Tabs,
    theme,
    Tooltip,
    Typography
} from 'antd'
import { useNavigate } from 'react-router-dom'
import { AdvertisingPlatforms } from './advertising-platforms'
import { MainForm } from './main-form'
import { OrdForm } from './ord-form'
const { Title, Text } = Typography

export const AddPartnerPage = () => {
    const items: TabsProps['items'] = [
        {
            key: '1',
            label: 'Основная информация',
            children: <MainForm />
        },
        {
            key: '2',
            label: 'Рекламные ресурсы',
            children: <AdvertisingPlatforms />,
            disabled: true
        },
        {
            key: '3',
            label: 'ОРД',
            children: <OrdForm />,
            disabled: true
        }
    ]

    const navigate = useNavigate()

    const { message } = App.useApp()

    const {
        token: { colorPrimary }
    } = theme.useToken()

    return (
        <Card>
            <Flex justify="space-between" align="center" style={{ marginBottom: '16px' }}>
                <Title level={3}>Добавление партнера</Title>
                <Button type="primary" onClick={() => navigate('/advertising/partners')}>
                    Назад <RollbackOutlined />
                </Button>
            </Flex>
            <Flex justify="space-between" align="center">
                <Space size={20} align="start">
                    <Avatar shape="circle" size={100} />
                    <Flex vertical={true} gap={6}>
                        <Title level={4} style={{ margin: 0 }}>
                            Имя партнера
                        </Title>

                        <Text italic>@username</Text>

                        <Text>E-mail</Text>
                        <Text>7(000)000-00-00</Text>
                    </Flex>
                </Space>
                <Flex vertical gap={16} align="flex-end">
                    <Row gutter={16} align={'middle'} justify={'end'}>
                        <Col span={'auto'}>
                            <Flex vertical gap={4}>
                                <Space>
                                    <Text style={{ color: colorPrimary }}>Пригласить в Telegaplan</Text>
                                    <Tooltip title="Если партнер еще не пользуется Telegaplan, скопируйте сообщение справа и отправьте его.">
                                        <QuestionCircleOutlined />
                                    </Tooltip>
                                </Space>

                                <Space.Compact>
                                    <Input
                                        value={`Я приглашаю тебя в ${window.location.origin}, самую удобную Crm для Telegram.`}
                                    />
                                    <Button
                                        type="primary"
                                        onClick={() =>
                                            navigator.clipboard
                                                .writeText(
                                                    `Я приглашаю тебя в ${window.location.origin}, самую удобную Crm для Telegram.`
                                                )
                                                .then(() => {
                                                    message.success('Скопировано в буфер обмена')
                                                })
                                        }
                                    >
                                        <CopyOutlined />
                                    </Button>
                                </Space.Compact>
                            </Flex>
                        </Col>
                    </Row>
                </Flex>
            </Flex>

            <Divider />
            <Tabs defaultActiveKey="1" items={items} />
        </Card>
    )
}
